import React, { Component } from 'react';
import { Dimmer, Loader, Image } from 'semantic-ui-react';

class HHImage extends Component {
  state = { showDimmer: !this.props.imgComponent };

  componentWillReceiveProps({ src: nextSrc }) {
    const { src } = this.props;
    if (src !== nextSrc) {
      this.setState({ showDimmer: true });
    }
  }

  render() {
    const { showDimmer } = this.state;
    return (
      <Dimmer.Dimmable>
        <Dimmer active={showDimmer} inverted>
          <Loader />
        </Dimmer>
        { this.props.imgComponent ||
          <Image
            alt='hackhub'
            onLoad={() => {
              this.setState({ showDimmer: false });
            }}
            {...this.props}
          />
        }
      </Dimmer.Dimmable>
    );
  }
}

export default HHImage;



// WEBPACK FOOTER //
// ./src/components/common/image.js